<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <p style="color: var(--color-icono); font-weight: 600" class="text-left">Cupones no disponibles del paciente</p>
    <div class="contenedorTablaSinColor pt-1 pb-1" style="min-height: 30vh">
      <b-row >
        <b-col sm="12" md="12" lg="12">
          <b-table
              id="tablaCuponesVigentes"
              thead-tr-class="columnasTablaSinColor"
              :items="datosTabla"
              :fields="fields"
              :per-page="registrosPorPagina"
              :current-page="paginaActual"
              responsive="true"
              class="parrafos"
              fixed>
            <template v-slot:cell(fechaExpedicion)="row">
              {{ row.item.fechaExpedicion | formatoFecha }}
            </template>
            <template v-slot:cell(fechaExpiracion)="row">
              {{ row.item.fechaExpiracion | formatoFecha }}
            </template>
            <template v-slot:cell(fechaAplicacion)="row">
              <span v-if="row.item.fechaAplicacion !== null">
                {{ row.item.fechaAplicacion | formatoFecha }}
              </span>
              <span v-else>
                -
              </span>
            </template>
            <template v-slot:cell(montoCupon)="row">
              <span v-if="row.item.idTipoDescuentoCupon === 1">
                {{ row.item.montoCupon + '%' }}
              </span>
              <span v-else>
                {{ row.item.montoCupon | moneda }}
              </span>
            </template>
            <template v-slot:cell(idReciboCupon)="row">
              {{ row.item.idReciboCupon !== null ? row.item.idReciboCupon : '-' }}
            </template>
          </b-table>


          <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="!loader">
            <b-alert v-if="datosTabla.length === 0" variant="warning" show>No hay datos</b-alert>
          </b-col>
          <b-col v-if="!loader && datosTabla.length > registrosPorPagina">
            <b-pagination
                align="center"
                v-model="paginaActual"
                :total-rows="datosTabla.length"
                :per-page="registrosPorPagina"
            ></b-pagination>
          </b-col>
        </b-col>
      </b-row>
    </div>
  </div>


</template>

<script>

export default {
  name: "cuponesNoDisponibles",

  data:()=>{
    return{
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      loader: false,
      loaderAcciones: false,

      datosTabla:[],
      fields:[
        {key: "idCupon", label:"ID Cupón", sortable: true},
        {key: "motivoCupon", label:"Motivo de Cupón", sortable: true},
        {key: "montoCupon", label:"Monto de Cupón", sortable: true},
        {key: "estatusCupon", label:"Tipo de Expiración", sortable: true},
        {key: "fechaExpedicion", label:"Fecha expedición", sortable: true},
        {key: "fechaAplicacion", label:"Fecha de uso", sortable: true},
        {key: "idReciboCupon", label:"Número de recibo", sortable: true},
      ],

      cuponesNoDisponibles:{
        idCupon:null,
        motivoCupon: null,
        montoCupon: null,
        estatusCupon:null,
        fechaExpedicion: null,
        fechaAplicacion: null,
        idReciboCupon: null
      },
      registrosPorPagina: 10,
      paginaActual: 0,
    }
  },

  created() {
    this.debug = this.$localStorageService.getDebug();

    this.obtener();
  },
  props:{
    idPaciente: Number,
  },
  methods:{

    obtener() {
      this.loader = true;
      this.datosTabla = [];
      this.$http.post(this.$api + 'catalogos/obtenerPacienteCuponNoDisponible', this.idPaciente ).then(respuesta => {
            if (respuesta.data.data) {
              respuesta.data.data.forEach(it => {
                this.paginaActual=1;
                this.datosTabla.push(it);
              })
            }

          }
      ).finally(() => {
            this.loader = false;
          }
      )
    },

  }

}
</script>

<style scoped>
.bCardAgenda {
  margin: 2%;
  padding: 0;
  border-radius: 20px;
}

.bCardAgenda .card-body {
  padding: 0.5rem;
}
</style>